import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=304a97ca&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=304a97ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a97ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('304a97ca')) {
      api.createRecord('304a97ca', component.options)
    } else {
      api.reload('304a97ca', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=304a97ca&scoped=true&", function () {
      api.rerender('304a97ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21l0gCnLvYxnO/JS/teamMember.vue"
export default component.exports